
import { ICategoryActions } from "../../action-types/san-pham/ICategoryActionType";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ICategoryReducer } from "../../reducer-model/san-pham/ICategoryReducer";
const iniState: ICategoryReducer = {
    status: eReducerStatusBase.is_not_initialization,
    categories: []
}
export const categoryReducer = (state: ICategoryReducer = iniState, action: ICategoryActions): ICategoryReducer => {
    switch (action.type) {
        case "CATEGORY_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "CATEGORY_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                categories: action.payload
            }
        case "CATEGORY_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "CATEGORY_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                categoryEditing: action.payload
            }
        case "CATEGORY_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "CATEGORY_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "CATEGORY_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: eReducerStatusBase.is_need_reload
            }
        case "CATEGORY_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "CATEGORY_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "CATEGORY_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "CATEGORY_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        default:
            return state;
    }
}